<app-auth-wrapper>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" class="row g-3">

    <h4 class="mb-0">{{"AUTH.RESET_PASSWORD"|translate}}</h4>

    <div class="col-sm-12 mb-2">
      <app-form-input [id]="'email'"
        [label]="('AUTH.EMAIL_ADDRESS'|translate)"
        [controlName]="'email'"
        [formGroup]="formGroup"
        [type]="'email'"
      [isRequired]="true"></app-form-input>
    </div>

    <div class="col-sm-12 mb-2">
      <app-form-input [id]="'password'"
        [label]="('AUTH.PASSWORD'|translate)"
        [controlName]="'password'"
        [formGroup]="formGroup"
        [type]="'password'"
        [minLength]="environment.passwordMinLength"
      [isRequired]="true"></app-form-input>
    </div>

    <div class="col-sm-12 mb-2">
      <app-form-input [id]="'confirmPassword'"
        [label]="('AUTH.CONFIRM_PASSWORD'|translate)"
        [controlName]="'confirmPassword'"
        [formGroup]="formGroup"
        [type]="'password'"
        [isRequired]="true">
        @if (getFormControl('confirmPassword')?.hasError('confirmedValidator') && (getFormControl('confirmPassword')?.dirty || getFormControl('confirmPassword')?.touched)) {
          <mdb-error>{{"VALIDATION.PASSWORDS_DO_NOT_MATCH"|translate}}.</mdb-error>
        }
      </app-form-input>
    </div>

    <!-- Submit button -->
    <div class="d-flex justify-content-center">
      <app-mdb-button [text]="'SAVE'"
        [isSubmit]="true"
      [loading]="loading"></app-mdb-button>
    </div>

  </form>
</app-auth-wrapper>
